module.exports = __webpack_public_path__ + "static/media/app-seo.a922ed39.png";